export default __webpack_public_path__ + "static/media/three_.eaf5fede.jpeg";